<app-header *ngIf="isHeaderVisible"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="isFooterVisible"></app-footer>
<!-- <app-preloader></app-preloader> -->
<app-active-call-chat-strip *ngIf="gS.showChatStrip" ></app-active-call-chat-strip>